var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100",attrs:{"id":"app"}},[_c('NavBar'),_c('div',{attrs:{"id":"current-page"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }